var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { baseCommon, configCommon, merchantCommon, } from '@repo/api/endpoints/merchant/msw/mocks/common';
export var LIBERIS_USER_HAS_OFFERS_FOR_LIBERIS = __assign(__assign({}, baseCommon), { type: 'IFRAME_MERCHANT_SUMMARY', currentProvider: ['liberis'], data: {
        merchantData: __assign(__assign({}, merchantCommon), { user: {
                type: 'user',
                userId: 12345,
                permission: {
                    widget: true,
                    newLoan: true,
                    cancelLoan: true,
                    continueLoan: true,
                },
                accessFor: ['193421', '1234', '4321'],
            } }),
        preLimits: [
            {
                id: 12345,
                min: 0,
                max: 0,
                currency: 'PLN',
                provider: 'liberis',
                availableLimitRevenueRate: [
                    {
                        period: 0,
                        pricing: 0,
                        loanRepaymentPrice: 0,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
            },
        ],
        limits: [
            {
                id: 1732011441,
                preLimitId: 1732011441,
                min: 3000,
                max: 50000,
                used: 0,
                currency: 'PLN',
                provider: 'liberis',
                availableLimitRevenueRate: [
                    {
                        period: 2,
                        pricing: 0,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 12,
                        pricing: 0,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
                minMaxDifference: false,
                available: 50000,
            },
        ],
        loans: [],
        agreements: {
            marketing: [
                {
                    provider: 'przelewy24',
                    accepted: true,
                    timestamp: '2024-05-16T07:38:18.593Z',
                },
            ],
        },
        transfers: [],
        offers: [
            {
                provider: 'liberis',
                preLimitId: 17272,
                offerId: '17272',
                amount: 10000,
                currency: 'PLN',
                period: 6,
                pricing: 17.5,
                loanRepaymentPrice: 11.76,
                name: 'KBCAG',
                createdAt: '2025-01-30 12:13:32',
                amountMin: 10000,
                amountMax: 20000,
            },
            {
                provider: 'liberis',
                preLimitId: 3172721,
                offerId: '3172721',
                amount: 10000,
                currency: 'PLN',
                period: 6,
                pricing: 15.5,
                loanRepaymentPrice: 10.76,
                name: 'BCAD',
                createdAt: '2025-01-30 12:13:32',
                amountMin: 10000,
                amountMax: 20000,
            },
            {
                provider: 'liberis',
                preLimitId: 3172721,
                offerId: '3172721',
                amount: 10000,
                currency: 'PLN',
                period: 6,
                pricing: 12.5,
                loanRepaymentPrice: 10.76,
                name: 'BCAD',
                createdAt: '2025-01-30 12:13:32',
                amountMin: 10000,
                amountMax: 20000,
            },
        ],
    }, config: [
        __assign(__assign({}, configCommon[0]), { provider: 'liberis' }),
    ] });
